// libraries
import React from 'react'
import { geoPath, geoMercator } from 'd3-geo'

// libs
import computeSize from '@st-operations/uikit/lib/computeSize.js'
import { geojson } from '_lib/us_states.js'

// component
class USStateMap extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: Math.random().toString(16).substr(2),
    }
  }

  static get defaultProps() {
    return {
      data: [], // default data
      fill: '#ededed', // default color
      height: -1, // height of the canvas
      state: 'CA', // which state to render
      stroke: '#cdcdcd', // default stroke
      strokeWidth: 2, // stroke width
      width: -1, // width of the canvas
      x: 0, // x position
      y: 0, // y position
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.state != this.props.state) {
      this.loadChartProps()
    }
  }

  UNSAFE_componentWillMount() {
    this.loadChartProps()
  }

  loadChartProps = () => {
    // read input
    var { data, fill, height, scale, state, stroke, strokeWidth, width, x, y } = this.props

    // data should be a dictionary {code: value}
    let min_value = 0
    let max_value = 0
    for (let key in data) {
      max_value = Math.max(max_value, data[key])
    }

    // only use current state geojson
    let state_geojson = {
      type: 'FeatureCollection',
      features: geojson.features.filter((feature) => {
        return feature.code == state
      }),
    }

    // compute canvas size
    var { height, width } = computeSize(width, height, 1920, 1080)

    // compute origin
    let padding = 0.05 * height

    // determine viewport bounds
    let bounds = [
      [2 * padding, padding],
      [width - 2 * padding, height - padding],
    ]

    // build projection
    let projection = geoMercator()

    // special case for Alaska
    if (state == 'AK') {
      projection.rotate([74, -32, 60])
    }

    // center and translate projection using fitExtent
    projection.fitExtent(bounds, state_geojson)

    // generate path generator function
    let getPath = geoPath(projection)

    // update state
    this.setState({
      bounds,
      data,
      fill,
      getPath,
      height,
      max_value,
      min_value,
      origin,
      padding,
      projection,
      scale,
      stroke,
      state_geojson,
      strokeWidth,
      width,
      x,
      y,
    })
  }

  render() {
    // read input
    const {
      bounds,
      height,
      width,
      x,
      y,
      state_geojson,
      data,
      max_value,
      fill,
      stroke,
      getPath,
      padding,
      projection,
      strokeWidth,
    } = this.state

    return (
      <svg
        className="world-map"
        data-custom-render="world-map"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        height={height}
        ref={this.map}
        viewBox={`0 0 ${width} ${height}`}
        width={width}
        x={x}
        y={y}
      >
        <g className="regions">
          <For each="region" of={state_geojson.features}>
            <g
              className="region"
              data-lat={region.lat}
              data-lng={region.lng}
              data-name={region.name}
              key={index}
              onMouseOut={this.onRegionMouseOut}
              onMouseOver={this.onRegionMouseOver}
              style={{ cursor: 'pointer' }}
            >
              {/*<defs>
                <linearGradient
                  id='state-gradient'
                  x1='0' x2='100%' y1='0' y2='0'
                >
                  <stop stopColor='#28d7c3' offset='0%'></stop>
                  <stop stopColor='#13682B' offset='100%'></stop>
                </linearGradient>
              </defs>*/}
              <path
                className="path"
                d={getPath(region)}
                fill={fill}
                stroke={stroke}
                strokeWidth={strokeWidth}
              />
            </g>
          </For>
        </g>
      </svg>
    )
  }
}

// export
export default USStateMap
